import { FeatureAnalysisRowDTO } from "@models/platform-analysis/entities/steps/feature";
import { Column, Row } from "@tanstack/react-table";
import { memo, useMemo } from "react";
import { TableVirtualizationConfigs } from "../../../configs";
import { AnalysisTableStickyCell } from "../sticky-cell";

type AnalysisTableStickyColumnsProps = {
  row: Row<FeatureAnalysisRowDTO>;
  columns: Column<FeatureAnalysisRowDTO>[];
  isRowExpanded: boolean;
};

export const AnalysisTableStickyColumns = memo(
  ({ row, columns, isRowExpanded }: AnalysisTableStickyColumnsProps) => {
    const visibleCells = row.getVisibleCells();

    const stickyColumns = useMemo(
      () => columns?.slice(0, TableVirtualizationConfigs.NumOfStickyColumn),
      [columns],
    );

    const cells = useMemo(
      () =>
        stickyColumns?.map((_, index) => (
          <AnalysisTableStickyCell
            key={`sticky-${row.original.id}-${index}`}
            cell={visibleCells[index]}
            isRowExpanded={isRowExpanded}
          />
        )),
      [stickyColumns, visibleCells, row.original.id, isRowExpanded],
    );

    return <>{cells}</>;
  },
);
